import styles from "./EhoZin.module.scss";
import "./Styles.css"

export const EhoZin = () => {
  return (
    <div className={styles.ehoZinWrapper}>
      <div className={styles.ehoZinMainPage}>
        <div className={styles.ehoZinLeftImageBlock}>
            <img
              src="https://static.wixstatic.com/media/c62a6c_e6c5bd84029a4af59259fff9f8967526~mv2.png/v1/fill/w_462,h_852,al_c,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/eho.png" />
        </div>

        <div className={styles.ehoZinLeftContentBlock}>
            <div className={styles.ehoZinBookTitle}>
                <p>СБОРНИК</p>
                <p>СОВРЕМЕННОЙ</p>
                <p>ПОЭЗИИ</p>
            </div>

            <div className={styles.ehoZinMainContent}>
                <p style={{fontWeight: "bold"}}>Содержание</p>
                <p><a href="./eho/authors/0">Введение. Почему не проза?</a></p>
                <p><a href="./eho/authors/1">Алексей Rojo Сычёв</a></p>
                <p><a href="./eho/authors/2">Маша Че</a></p>
                <p><a href="./eho/authors/3">Булат Галеев</a></p>
                <p><a href="./eho/authors/4">Алексей Барков</a></p>
                <p><a href="./eho/authors/5">Марат Каракурт</a></p>
                <p><a href="./eho/authors/6">Саша Кам</a></p>
                <p><a href="./eho/authors/7">Справедливый орешек</a></p>
                <p><a href="./eho/authors/8">1848</a></p>
                <p><a href="./eho/authors/9">Антон Морван</a></p>
                <p><a href="./eho/authors/10">L.T. Korneev</a></p>
                <p><a href="./eho/authors/11">З. Sobakin</a></p>
                <p><a href="./eho/authors/12">Сергей Сплинов</a></p>
                <p><a href="./eho/authors/13">Ян Куян</a></p>
                <p><a href="./eho/authors/14">Тимур Могжанов</a></p>
            </div>
        </div>
      </div>
    </div>
  );
};
